const domList = [
  'el-header',
  'cml-menus-list',
  'el-tabs__header',
  'cml-search-form',
  'cml-button-group',
  'cml-pagination',
  'el-tabs--border-card',
  'cml-divider',
  'search-box',
  'gift-search-box'
]

export default {
  // 改变table高度 arr—dom元素， num——手动修改高度
  computeTableHeight(arr = domList, num = 0) {
    let height = 0
    arr.forEach(item => {
      let hei = document.getElementsByClassName(item).length > 0 ? document.getElementsByClassName(item)[0].offsetHeight : 0;
      height += hei
    })
    return document.body.clientHeight - height - num
  }
}